var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa",class:[_vm.name],style:({ fontSize: _vm.fontSize + 'px' }),attrs:{"aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }